import { createSelector } from '@reduxjs/toolkit';
import { JobDefinitionState } from 'ducks/job-definition/slices';
import { RootState } from 'store';

const jobDefinitionSlice = (state: RootState) => state.job_definition;

export const selectJobDefinition = createSelector([jobDefinitionSlice], (state): JobDefinitionState => state);
